"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberCertificationOwnerSchema = exports.AdultStatus = exports.CheckCISchema = exports.CreateTokenSchema = exports.AuthenticationErrorCode = exports.AUTHENTICATION_RESULT_CODE = void 0;
var zod_1 = require("zod");
exports.AUTHENTICATION_RESULT_CODE = {
    SUCCESS: 'SUCCESS',
    ALREADY_CERTIFICATED: 'ALREADY_CERTIFICATED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
    EXIST_AUTHENTICATION_IN_OTHER_MEMBER: 'EXIST_AUTHENTICATION_IN_OTHER_MEMBER',
    LOGIN_REQUIRED: 'LOGIN_REQUIRED',
    NOT_EXIST_TOKEN: 'NOT_EXIST_TOKEN',
    UNDER_14_YEARS: 'UNDER_14_YEARS',
    NOT_EQUALS_WITH_EXISTED_AUTHENTICATION: 'NOT_EQUALS_WITH_EXISTED_AUTHENTICATION',
    NOT_ALLOW_CERTIFICATED_WITHDRAW: 'NOT_ALLOW_CERTIFICATED_WITHDRAW',
};
exports.AuthenticationErrorCode = {
    NOT_EXIST_MEMBER: 'NOT_EXIST_MEMBER',
    NOT_EXIST_AGREEMENT: 'NOT_EXIST_AGREEMENT',
    NOT_CERTIFICATED_MEMBER: 'NOT_CERTIFICATED_MEMBER',
};
exports.CreateTokenSchema = zod_1.z.object({
    returnUrl: zod_1.z.string(),
});
exports.CheckCISchema = zod_1.z.object({
    ci: zod_1.z.boolean(),
});
exports.AdultStatus = {
    ADULT: 'ADULT',
    NOT_ADULT: 'NOT_ADULT',
    EXPIRED: 'EXPIRED',
};
exports.MemberCertificationOwnerSchema = zod_1.z.object({
    ownerEmail: zod_1.z.string(),
    ownerLastLoginType: zod_1.z.string().nullable(),
    ownerMemberType: zod_1.z.string(),
});
